/* arvz: behaviour of the reference-port sections (behaviour ported from the reference's own inline scripts).
   Everything content-related works without this file: panels, steps and tabs are only hidden once .az-js is set. */
(function () {
  if (window.__arvz) return; window.__arvz = 1;
  var doc = document.documentElement;
  doc.classList.add('az-js'); window.__arvzReady = 1;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  // gallery: arrows, thumbs, swipe (scroll-snap), variant media jump
  function galleries() {
    each('[data-az-gal]', function (g) {
      if (!once(g, 'azGal')) return;
      var track = g.querySelector('.azm-gal__track'); if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.azm-gal__thumb'));
      function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
      function mark() { var i = idx(); thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
      var p = g.querySelector('.azm-gal__arrow--prev'), n = g.querySelector('.azm-gal__arrow--next');
      if (p) p.addEventListener('click', function () { go(idx() - 1); });
      if (n) n.addEventListener('click', function () { go(idx() + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { thumbs.forEach(function (x, j) { x.setAttribute('aria-current', j === k ? 'true' : 'false'); }); go(k); }); });
      var tm = null; track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(mark, 60); }, { passive: true });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); } });
      g.addEventListener('az:media', function (e) { var k = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(e.detail); }); if (k > -1) go(k); });
    });
  }

  // bundle tiers: price outputs. The radios carry a QUANTITY of one variant (bundles = N units), never a variant id,
  // so nothing here may write ?variant= from them.
  function tiers() {
    each('[data-az-buy]', function (bb) {
      if (!once(bb, 'azBuy')) return;
      var radios = Array.prototype.slice.call(bb.querySelectorAll('.azt-opt input[type="radio"]'));
      function sync(user) {
        var r = radios.filter(function (x) { return x.checked; })[0]; if (!r) return;
        each('[data-az-price-out]', function (o) { o.textContent = r.getAttribute('data-price'); });
        // buy button (and the sticky bar's copy of it): the picked option's own label, then price + saving
        if (r.hasAttribute('data-cta')) each('[data-az-cta]', function (o) { o.textContent = r.getAttribute('data-cta'); });
        if (r.hasAttribute('data-cta-sub')) each('[data-az-cta-sub]', function (o) { o.textContent = r.getAttribute('data-cta-sub'); });
        if (!user) return;
        var mid = r.getAttribute('data-media-id'), gal = bb.querySelector('[data-az-gal]');
        if (mid && gal) gal.dispatchEvent(new CustomEvent('az:media', { detail: mid }));
      }
      radios.forEach(function (r) { r.addEventListener('change', function () { sync(true); }); });
      sync(false);
    });
  }

  // stats count-up (reference: 1100 ms ease-out cubic), restores the exact original text at the end
  function counts() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-az-count]'));
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    function run(el) {
      var txt = el.textContent, m = txt.match(/\d+/); if (!m) return;
      var target = parseInt(m[0], 10), start = null, dur = 1100;
      function step(t) {
        if (start === null) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = txt.replace(m[0], String(Math.round(target * (1 - Math.pow(1 - p, 3)))));
        if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); }, { threshold: .4 });
    els.forEach(function (e) { if (once(e, 'azCount')) io.observe(e); });
  }

  // horizontal rails with prev/next (testimonial cards: also dim the cards that are not fully in view)
  function rails() {
    each('[data-az-rail-box]', function (box) {
      if (!once(box, 'azRail')) return;
      var rail = box.querySelector('[data-az-rail]'); if (!rail) return;
      var cards = Array.prototype.slice.call(rail.children);
      var btns = Array.prototype.slice.call(box.querySelectorAll('[data-az-dir]'));
      var dim = rail.hasAttribute('data-az-dim');
      function state() {
        var g = rail.scrollLeft, r = g + rail.clientWidth;
        if (dim) cards.forEach(function (c) { var a = c.offsetLeft - rail.offsetLeft, b = a + c.offsetWidth; c.classList.toggle('is-near', a >= g - 12 && b <= r + 12); });
        btns.forEach(function (b) { var s = +b.getAttribute('data-az-dir'); b.disabled = (s < 0 && g <= 2) || (s > 0 && g >= rail.scrollWidth - rail.clientWidth - 2); });
      }
      // step by card index, not by the current scrollLeft: a second click during the smooth scroll would otherwise start
      // from a half-way position and land between cards (reviewer finding 11-10)
      var idx = 0;
      function nearest() { var g = rail.scrollLeft, best = 0, d = Infinity; cards.forEach(function (c, k) { var x = Math.abs(c.offsetLeft - rail.offsetLeft - g); if (x < d) { d = x; best = k; } }); return best; }
      function maxIdx() { var m = rail.scrollWidth - rail.clientWidth; for (var k = 0; k < cards.length; k++) { if (cards[k].offsetLeft - rail.offsetLeft >= m - 2) return k; } return cards.length - 1; }
      btns.forEach(function (b) { b.addEventListener('click', function () {
        idx = Math.max(0, Math.min(maxIdx(), idx + (+b.getAttribute('data-az-dir'))));
        var c = cards[idx]; if (c) rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }); });
      var t = null; rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { idx = nearest(); state(); }, 90); }, { passive: true });
      window.addEventListener('resize', state);
      requestAnimationFrame(state);
    });
  }

  // accordion cards: one open per column (reference behaviour), first open from the markup. The open height is measured
  // (--az-h) so a long document answer is never cut by a fixed max-height.
  function accordions() {
    function fit(acc) { var p = acc.querySelector('.azb-panel'); if (p) p.style.setProperty('--az-h', (p.scrollHeight + 2) + 'px'); }
    each('[data-az-acc]', function (acc) {
      if (!once(acc, 'azAcc')) return;
      var btn = acc.querySelector('button'); if (!btn) return;
      btn.setAttribute('aria-expanded', acc.classList.contains('is-open') ? 'true' : 'false');
      fit(acc);
      btn.addEventListener('click', function () {
        var open = acc.classList.contains('is-open');
        each('[data-az-acc].is-open', function (o) { if (o !== acc) { o.classList.remove('is-open'); o.querySelector('button').setAttribute('aria-expanded', 'false'); } }, acc.parentElement);
        fit(acc);
        acc.classList.toggle('is-open', !open); btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
    var rt = null;
    addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { each('[data-az-acc]', fit); }, 120); }, { passive: true });
  }

  // tabs (reference switch: data-open="1" on the shown panel); every panel is readable until .az-js is set
  function tabs() {
    each('[data-az-tabs]', function (box) {
      if (!once(box, 'azTabs')) return;
      var list = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      function sel(t, focus) {
        list.forEach(function (x) {
          var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.setAttribute('data-open', on ? '1' : '0');
        });
        if (focus) t.focus();
      }
      list.forEach(function (t, k) {
        t.addEventListener('click', function () { sel(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = list[(k + 1) % list.length]; if (e.key === 'ArrowLeft') n = list[(k - 1 + list.length) % list.length];
          if (e.key === 'Home') n = list[0]; if (e.key === 'End') n = list[list.length - 1];
          if (n) { e.preventDefault(); sel(n, true); }
        });
      });
      sel(list.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; })[0] || list[0], false);
    });
  }

  // timeline steps fade in (reference: threshold .25)
  function steps() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.azl-step'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-on'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-on'); io.unobserve(e.target); } }); }, { threshold: .25 });
    els.forEach(function (e) { if (once(e, 'azStep')) io.observe(e); });
  }

  // reviews: show the rest
  function more() {
    each('[data-az-more]', function (btn) {
      if (!once(btn, 'azMore')) return;
      btn.addEventListener('click', function () { each('.azw-rev.is-more', function (r) { r.classList.remove('is-more'); }, btn.closest('.az')); btn.hidden = true; });
    });
  }

  // sticky bar (reference behaviour): on whenever the main button is out of view, above or below; off over the footer
  function sticky() {
    each('[data-az-sticky]', function (bar) {
      if (!once(bar, 'azSticky')) return;
      var atc = document.querySelector('[data-az-atc]'); if (!atc) return;
      var foot = document.querySelector('footer, .footer, [id*="footer-group"]'), q = false;
      function upd() {
        q = false; if (!bar.isConnected) return;
        var r = atc.getBoundingClientRect();
        var on = (r.bottom < 0 || r.top > innerHeight) && !(foot && foot.getBoundingClientRect().top < innerHeight);
        if (bar.classList.contains('is-on') !== on) { bar.classList.toggle('is-on', on); bar.inert = !on; }
      }
      bar.inert = true;
      addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(upd); } }, { passive: true });
      addEventListener('resize', upd, { passive: true }); upd();
    });
  }

  // add to cart -> the cart drawer opens (owner 11-10) instead of a jump to checkout. The sticky bar's button submits the
  // same form. No drawer, no arvc.js or any error: the form posts normally (/cart/add, then the cart page).
  function ajaxAdd() {
    each('[data-az-buy] form', function (f) {
      if (!once(f, 'azAjax')) return;
      f.addEventListener('submit', function (e) {
        if (!window.arvcAdd || !document.querySelector('cart-drawer') || !window.fetch) return;
        e.preventDefault();
        var fd = new FormData(f);
        var btns = Array.prototype.slice.call(document.querySelectorAll('[data-az-atc], .azk .azm-atc'));
        btns.forEach(function (b) { b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); });
        window.arvcAdd([{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }], e.submitter || null)
          .catch(function () { HTMLFormElement.prototype.submit.call(f); })
          .finally(function () { btns.forEach(function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); }); });
      });
    });
  }

  function init() { galleries(); tiers(); ajaxAdd(); counts(); rails(); accordions(); tabs(); steps(); more(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[role="tab"]'); if (t) t.click();
    var a = e.target && e.target.closest && e.target.closest('[data-az-acc]'); if (a && !a.classList.contains('is-open')) a.querySelector('button').click();
  });
})();
